/**
 * Trunnion AI - Audit Page
 */

import { AuditLogViewer } from '@/components/audit/AuditLogViewer';

export default function AuditPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Audit Log</h1>
        <p className="mt-1 text-sm text-trunnion-slate-400">
          Complete audit trail of all platform activities for compliance and security.
        </p>
      </div>
      <AuditLogViewer />
    </div>
  );
}
